import { Grid } from "@mui/material";
import { DASHBOARD_STATS_DATA } from "../../constant";
import StatCard from "../../components/StatCard/StatCard";

const deriveCountsFromPayload = (payload) => {
  const defaults = {
    totalScheduled: 0,
    totalInProgress: 0,
    totalCompleted: 0,
    reportedToZoho: 0,
    totalFailed: 0,
  };

  if (!payload) return defaults;

  if (typeof payload.totalScheduled !== "undefined") {
    return {
      totalScheduled: payload.totalScheduled || 0,
      totalInProgress: payload.totalInProgress || 0,
      totalCompleted: payload.totalCompleted || 0,
      reportedToZoho: payload.reportedToZoho || 0,
      totalFailed: payload.totalFailed || 0,
    };
  }

  const interviews = Array.isArray(payload.interviews) ? payload.interviews : Array.isArray(payload) ? payload : null;
  if (interviews) {
    const totalScheduled = interviews.filter((i) => i.status === "Scheduled").length;
    const totalInProgress = interviews.filter((i) => i.status === "InProgress").length;
    const totalCompleted = interviews.filter((i) => i.status === "Completed").length;
    const reportedToZoho = interviews.filter((i) => i.isPassed === true).length;
    const totalFailed = interviews.filter((i) => i.isPassed === false).length;
    return { totalScheduled, totalInProgress, totalCompleted, reportedToZoho, totalFailed };
  }

  return defaults;
};

const DashboardStats = ({ interviewCount }) => {
  const counts = deriveCountsFromPayload(interviewCount);

  const getCountForStat = (id) => {
    switch (id) {
      case "interview-conducted":
        return counts.totalScheduled;
      case "pending-interview":
        return counts.totalInProgress;
      case "interview-completed":
        return counts.totalCompleted;
      case "reported-zoho":
        return counts.reportedToZoho;
      default:
        return 0;
    }
  };

  return (
    <Grid container spacing={3}>
      {DASHBOARD_STATS_DATA &&
        DASHBOARD_STATS_DATA.map((stat) => (
        <Grid key={stat.id} item size={{ xs: 12, sm: 6, md: 3 }}>
            <StatCard {...stat} value={getCountForStat(stat.id)} />
          </Grid>
        ))}
    </Grid>
  );
};

export default DashboardStats;
